import { ECheckboxSizes, TCheckboxSizes } from '@components/common/Checkbox/Checkbox.types';

export const getBeforeElementStyles = (size: TCheckboxSizes) => {
	switch (size) {
		case ECheckboxSizes.md:
			return {
				width: '20px',
				height: '20px',
				borderRadius: '4px',
			};
		case ECheckboxSizes.lg:
			return {
				width: '30px',
				height: '30px',
				borderRadius: '6px',
			};
	}
};

export const getAfterElementStyles = (size: TCheckboxSizes, isIndefinite?: boolean) => {
	switch (size) {
		case ECheckboxSizes.md:
			return {
				width: isIndefinite ? '10px' : '6px',
				height: '10px',
				borderRightWidth: '2px',
				borderBottomWidth: '2px',
			};
		case ECheckboxSizes.lg:
			return {
				width: '10px',
				height: '16px',
				borderRightWidth: '3px',
				borderBottomWidth: '3px',
				left: 0,
				transform: 'rotate(13deg) skew(-26deg, 25deg) translateY(calc(-50% - 4px))',
			};
	}
};
